import { render, staticRenderFns } from "./Scrollable.vue?vue&type=template&id=6f503c48"
import script from "./Scrollable.vue?vue&type=script&lang=js"
export * from "./Scrollable.vue?vue&type=script&lang=js"
import style0 from "./Scrollable.vue?vue&type=style&index=0&id=6f503c48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports